import { sharedUrls } from './environment.urls';
import { REVISION, VERSION } from './revision';

export const environment = {
  gtmContainerId: 'GTM-WZXPXV73',
  analyticsEnv: 'test',
  firebase: {
    apiKey: 'AIzaSyAU1I2lfRbzoKjX4aeFZofeAgNeKTUmvig',
    authDomain: 'spog-gopher-testing.firebaseapp.com',
    projectId: 'spog-gopher-testing',
    storageBucket: 'spog-gopher-testing.firebasestorage.app',
    messagingSenderId: '303669706653',
    appId: '1:303669706653:web:bbd42426df2a96912eb974',
  },
  urls: {
    backendApi: 'https://spog-backend.test.gopher.cdw.com/api',
    ...sharedUrls,
  },
  production: false,
  revision: REVISION,
  version: VERSION,
};
